var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",staticClass:"ui-trigger",class:{
        _disabled: _vm.isDisabled,
        _plain: _vm.isPlainText,
    },attrs:{"type":_vm.type ? _vm.type : null},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }